import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';
import { EMPTY_RIDER } from '@/store/ridesWizard';
import { useCopy } from '@/lib/settings';
import { StepHeader } from '@/components/ui/StepHeader';
import { LoadingState } from '@/components/ui/LoadingState';
import { ErrorState } from '@/components/ui/ErrorState';
import { EventPicker } from '@/components/rides/EventPicker';
import { useRiderFlow } from './_shared';

/** Find a ride, step 1: the service or event. Choosing one moves on; a different event clears the later choices. */
export default function RideEventPage() {
  const navigate = useNavigate();
  const { t } = useCopy();
  const f = useRiderFlow();
  const { events, rider, setRider } = f;

  return (
    <div className="rides-main rides-flow">
      <StepHeader step={1} total={f.firstTotal} title="Where are you going?" lede={t('ride.event_intro')} hideBack />
      <div className="rides-stepbody">
      {events.isLoading && <LoadingState label="Loading services and events" count={3} />}
      {events.error && (
        <ErrorState
          title="We couldn't load the services"
          error={events.error}
          onRetry={() => events.refetch()}
          retrying={events.isFetching}
          secondaryAction={<Button component={Link} to="/home" variant="default" fullWidth>Back to Home</Button>}
        />
      )}
      {events.data && (
        <EventPicker
          events={events.data}
          value={rider.eventId}
          showDriverCount
          emptyAction={<Button component={Link} to="/home" variant="default" fullWidth>Back to Home</Button>}
          onSelect={(id) => {
            if (id !== rider.eventId) setRider({ ...EMPTY_RIDER, eventId: id });
            navigate('/ride/route');
          }}
        />
      )}
      </div>
    </div>
  );
}
